import React, { Component } from 'react';
import { observer } from 'mobx-react';
import b_ from 'b_';
import { DataLossPreventionStore } from '../../stores/BrowserPolicies/DLPStore';
import Modal from '../Modal';
import Box from '../Box/Box';
import Button from '../Button';
import Toggle from '../Toggle/Toggle';
import ControlWrapper from '../ConsoleFragments/ConsoleField';
import PasteLimitField from './PasteLimitField';
import UrlPatternInput from '../UrlPatternInput/UrlPatternInput';
import './DomainConfigurationModal.css';

const block = b_.lock('DomainConfigurationModal');

class DomainConfigurationModal extends Component {
    static propTypes = {
        dlp: DataLossPreventionStore.PropType.isRequired,
    };

    onSubmit = (event) => {
        event.preventDefault();

        this.props.dlp.doSubmit();
    };

    render() {
        const { domainConfigurationModal, domainConfigurationModalStore } = this.props.dlp;
        const { urlGuidelines, domainConfig, index } = domainConfigurationModalStore;
        const { options, domainStore } = domainConfig;
        const isEditing = index !== null;

        return (
            <Modal
                isOpen={domainConfigurationModal.isOpen}
                overlayClassName={block('Overlay')}
                className={block('Content')}
            >
                <Box title={isEditing ? 'Edit Domain' : 'Add New Domain'}>
                    <form noValidate onSubmit={this.onSubmit}>
                        <UrlPatternInput
                            inputStore={domainStore}
                            guidelines={urlGuidelines}
                            className={block('UrlPatternInput')}
                            inputLabel={'Domain'}
                            guidelinesHeader={'Guidelines for adding domains:'}
                            legacy
                        />

                        <div className={block('Grid')}>
                            <ControlWrapper name="All Input" className={block('GridItem')}>
                                <Toggle
                                    onLabel={'ENABLED'}
                                    offLabel={'DISABLED'}
                                    checked={!options.allInputStore.isEnabled}
                                    onChange={options.allInputStore.toggle}
                                />
                            </ControlWrapper>

                            <ControlWrapper
                                name="Clipboard Paste"
                                className={block('GridItem')}
                                disabled={options.allInputStore.isEnabled}
                            >
                                <Toggle
                                    onLabel={'ENABLED'}
                                    offLabel={'DISABLED'}
                                    checked={!options.clipboardPasteStore.isEnabled}
                                    onChange={options.clipboardPasteStore.toggle}
                                />
                            </ControlWrapper>

                            <ControlWrapper
                                className={block('GridItem')}
                                name="Paste Limit"
                                disabled={options.clipboardPasteStore.isEnabled}
                            >
                                <Toggle
                                    onLabel={'ENABLED'}
                                    offLabel={'DISABLED'}
                                    checked={options.pasteLimitEnabledStore.isEnabled}
                                    onChange={options.pasteLimitEnabledStore.toggle}
                                />
                            </ControlWrapper>

                            <ControlWrapper
                                className={block('GridItem')}
                                name="Paste Limit Maximum"
                                disabled={options.clipboardPasteStore.isEnabled ||
                                !options.pasteLimitEnabledStore.isEnabled}
                            >
                                <PasteLimitField store={options.pasteLimitStore} />
                            </ControlWrapper>
                        </div>

                        <div className={block('Controls')}>
                            <Button
                                raised
                                secondaryWhite
                                onClick={domainConfigurationModal.close}
                                className={block('ControlsItem')}
                            >Cancel</Button>

                            <Button
                                raised
                                primaryGreen
                                onClick={this.onSubmit}
                                className={block('ControlsItem')}
                                disabled={!this.props.dlp.canSubmit()}
                            >{isEditing ? 'Save Domain' : 'Add Domain'}</Button>
                        </div>
                    </form>
                </Box>
            </Modal>
        );
    }
}

export default observer(DomainConfigurationModal);
